export class LiveVideo {
    constructor() {
        this.init();
    };

    init() {
        const liveVideo = $("#live-video");
        const liveVideoChannel = $(".live-video-channel");

        if (!liveVideo.length) {
            return;
        }

        // Get data active element
        const activeChannelVideoId = $(".section-header__tabs").find(".active").first().data("videoChannelId");

        // Set active channel video id
        const videoPlayerId = liveVideo.find(".video-js")[0].id;
        videojs(videoPlayerId).ready(function() {
            const myPlayer = this;

            myPlayer.catalog.getVideo(activeChannelVideoId, (error, video) => {
                myPlayer.catalog.load(video);
                myPlayer.play();
            });
        });

        // On channel change
        liveVideoChannel.click((e) => {
            e.preventDefault();
            e.stopPropagation();

            // get new channel id
            const changeChannelVideoId = $(this).data("videoChannelId");

            // Is side content?? - Change active button
            liveVideoChannel.removeClass("active");
            $(".media-info--top-right").removeClass("active");
            if ($(this).hasClass("live-video-channel--side")) {
                $(this).closest(".card-news").find(".card-news__media .media-info--top-right").addClass("active")
            } else {
                $(this).addClass("active");
            }

            // set new video channel
            videojs(videoPlayerId).ready(() => {
                myPlayer = this;

                myPlayer.catalog.getVideo(changeChannelVideoId, (error, video) => {
                    myPlayer.catalog.load(video);
                    myPlayer.play();
                });
            });
        });
    }
}
